/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { ServiceCreateModalWithoutProjectContext as ServiceCreateModalWithProjectContextType } from '@jira/spa-apps__servicedesk-service-create-modal-without-project-context/src/ServiceCreateModalWithoutProjectContext.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServiceCreateModalWithProjectContext: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServiceCreateModalWithProjectContextType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-service-create-modal-without-project-context", jiraSpaEntry: "async-servicedesk-service-create-modal-without-project-context" */ '@jira/spa-apps__servicedesk-service-create-modal-without-project-context/src/ServicedeskServiceCreateModalWithoutProjectContext.tsx'
			),
	);

const AsyncServiceCreateModalWithProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServiceCreateModalWithProjectContext}
		pageId="spa-apps/servicedesk/service-create-modal"
		shouldShowSpinner
	/>
);

export default AsyncServiceCreateModalWithProjectContext;
